<template>
    <div id="other-contacts-container">
        <div class="contact-container" v-for="item in otherContactsContent">
            <div class="contact-intro">
                <div class="contact-title-wrapper">
                    <i class="icon-cr" :class="item.iconName" id="icon-test" />
                    <h2 class="form-title">{{ item.title }}</h2>
                </div>
                <div class="contact-description">
                    <p v-for="description in item.description">
                        {{ description }}
                    </p>
                </div>
            </div>
            <button
                v-if="item.title === 'Chat'"
                @click="openChat()"
                type="button"
                class="btn btn-contact"
            >
                {{ item.buttonText }}
            </button>
            <a v-if="item.title !== 'Chat'" :href="item.url" target="_blank">
                <button type="button" class="btn btn-contact">
                    {{ item.buttonText }}
                </button>
            </a>
        </div>
    </div>
</template>

<script>
    import { initAlerts } from '../../../common/cr-components';

    export default {
        name: 'OtherContacts',
        data() {
            return {
                otherContactsContent: [
                    {
                        title: 'Chat',
                        iconName: 'icon-chat',
                        description: [
                            'Clique no botão abaixo para abrir um atendimento na nossa plataforma de chat.',
                            'De segunda à sexta, temos atendentes de plantão para este canal.',
                        ],
                        buttonText: 'Iniciar Chat',
                    },
                    // {
                    //     title: 'Atendimento por Whatsapp',
                    //     iconName: 'icon-whatsapp',
                    //     description: [
                    //         'Clique no botão abaixo para começar um atendimento via Whatsapp.',
                    //         'Retornaremos seu contato em até um dia útil.',
                    //     ],
                    //     buttonText: 'Ir para WhatsApp',
                    //     url: 'https://api.whatsapp.com/send/?phone=553298519024&text&type=phone_number&app_absent=0',
                    // },
                    {
                        title: 'Central de Ajuda',
                        iconName: 'icon-helpcenter',
                        description: [
                            'Sua dúvida pode estar na nossa Central de Ajuda.',
                            'Você encontrará uma biblioteca de artigos com diversas informações e orientações.',
                        ],
                        buttonText: 'Acessar Central de Ajuda',
                        url: '/central-de-ajuda',
                    },
                ],
            };
        },
        mounted() {
            initAlerts();
        },
        methods: {
            openChat() {
                cr$.byId('olark-tab').click();
            },
        },
    };
</script>
